// Dữ liệu các dòng sản phẩm của Ann Home (nội dung lấy từ catalogue thật)
const TT = "/images/tt";

/* ============================ BÁNH TRUNG THU ============================ */
export const mooncake = {
  collection: "Mộc Hương Thu Nguyệt",
  year: "Collection 2026",
  poem: [
    "Áo thu sương khói quyện mây bay,",
    "Hương đượm đài sen lẫn gió ngày.",
    "Dưới bóng hoa tàn, trà ấm rót,",
    "Gia đình sum họp, chén nồng say.",
  ],
  cover: `${TT}/page-01.webp`,
  intro:
    "Mùa trăng 2026, Ann Home kể lại câu chuyện của căn bếp thức giấc: những chiếc bánh nướng thơm mùi mộc, những sắc màu từ rau củ tự nhiên và những set quà được gói bằng sự tử tế. Mỗi hộp bánh là một lời chúc gửi đến gia đình bạn.",
  notes: [
    "Bánh đều là 1 trứng, thêm 1 trứng +8k/bánh",
    "Bánh không trứng bằng giá bánh cùng loại",
    "Mẫu khuôn cố định theo bộ sưu tập",
    "HSD 12 ngày kể từ ngày sản xuất",
    "Bánh hoa ngàn lớp: chốt order và trả đơn thứ 3, thứ 6 hàng tuần",
  ],
  lines: [
    {
      id: "truyen-thong",
      name: "Trung thu Truyền thống",
      desc: "Vỏ bánh nướng vàng mật, khuôn hoa cổ điển, giữ đúng hương vị trung thu xưa.",
      image: `${TT}/page-05.webp`,
    },
    {
      id: "sac-mau",
      name: "Trung thu Sắc màu",
      desc: "Vỏ bánh lên màu từ rau củ, than tre, matcha... rực rỡ mà vẫn thuần tự nhiên.",
      image: `${TT}/page-06.webp`,
    },
    {
      id: "hoa-ngan-lop",
      name: "Bánh Hoa ngàn lớp",
      desc: "Bánh 70g tạo hình hoa trái, ngàn lớp vỏ mỏng tan, làm theo lịch cố định mỗi tuần.",
      image: `${TT}/page-14.webp`,
    },
  ],
  flavorGroups: [
    {
      id: "man",
      label: "Nhân mặn",
      price170: "70.000đ",
      price220: "85.000đ",
      items: [
        "Thập cẩm gà quay, jambon",
        "Thập cẩm xá xíu lạp vị",
        "Thập cẩm bò xốt Tứ Xuyên",
        "Thập cẩm hải sản xốt X.O",
      ],
    },
    {
      id: "hottrend",
      label: "Nhân ngọt hot trend",
      price170: "65.000đ",
      price220: "80.000đ",
      items: [
        "Khoai môn mochi chà bông",
        "Đậu xanh mặn chà bông",
        "Dừa non cốm tươi Hà Nội",
        "Dứa xoài thanh nhiệt",
      ],
    },
    {
      id: "premium",
      label: "Nhân ngọt premium",
      price170: "65.000đ",
      price220: "80.000đ",
      items: [
        "Đậu xanh dừa nướng caramel",
        "Đậu xanh sầu riêng",
        "Hạt sen táo đỏ",
        "Sen olong lài nhãn",
        "Chocolate mocha",
        "Sữa dừa non",
        "Dừa non sầu riêng",
        "Rượu hạt quả mọng berry",
      ],
    },
  ],
  sets: [
    {
      id: "cat-tuong-vien",
      name: "Cát Tường Viên",
      tier: "Set 4 bánh · Luxury",
      price: "385.000đ",
      size: "Size bánh 170g · truyền thống",
      image: `${TT}/page-08.webp`,
      flavors: [
        "Thập cẩm bò xốt Tứ Xuyên",
        "Thập cẩm hải sản xốt X.O",
        "Sen olong lài nhãn",
        "Rượu hạt quả mọng berry",
      ],
      highlight: true,
    },
    {
      id: "nguyet-cuc-an",
      name: "Nguyệt Cúc An",
      tier: "Set 4 bánh · Premium",
      price: "350.000đ",
      size: "Size bánh 170g · truyền thống",
      image: `${TT}/page-09.webp`,
      flavors: [
        "Thập cẩm gà quay, jambon",
        "Thập cẩm bò xốt Tứ Xuyên",
        "Hạt sen táo đỏ",
        "Dừa non sầu riêng",
      ],
    },
    {
      id: "nguyet-da-hoa",
      name: "Nguyệt Dạ Hoa",
      tier: "Set 4 bánh",
      price: "325.000đ",
      size: "Size bánh 170g · truyền thống",
      image: `${TT}/page-10.webp`,
      flavors: [
        "Thập cẩm gà quay, jambon",
        "Thập cẩm xá xíu lạp vị",
        "Dừa non cốm tươi Hà Nội",
        "Đậu xanh sầu riêng",
      ],
    },
    {
      id: "moc-lan-khue",
      name: "Mộc Lan Khuê",
      tier: "Set 4 bánh",
      price: "325.000đ",
      size: "Size bánh 170g · truyền thống",
      image: `${TT}/page-11.webp`,
      flavors: [
        "Thập cẩm hải sản xốt X.O",
        "Thập cẩm xá xíu lạp vị",
        "Chocolate mocha",
        "Đậu xanh dừa nướng caramel",
      ],
    },
    {
      id: "hai-duong-yen",
      name: "Hải Đường Yên",
      tier: "Set 6 bánh",
      price: "455.000đ",
      size: "Size bánh 170g · truyền thống",
      image: `${TT}/page-12.webp`,
      flavors: [
        "Thập cẩm gà quay, jambon",
        "Thập cẩm xá xíu lạp vị",
        "Khoai môn mochi chà bông",
        "Sen olong lài nhãn",
        "Sữa dừa non",
        "Dứa xoài thanh nhiệt",
      ],
    },
    {
      id: "nguyet-doan-vien",
      name: "Nguyệt Đoàn Viên",
      tier: "Set 6 bánh mini",
      price: "259.000đ",
      size: "Size bánh 75g",
      image: `${TT}/page-13.webp`,
      flavors: [
        "Chocolate lava",
        "Đậu xanh sầu riêng lava",
        "Olong lài nhãn lava",
        "Dâu tây berry phô mai",
        "Sen táo đỏ hồng dẻo Đài Loan",
        "Trái cây nhiệt đới xốt xoài",
      ],
    },
    {
      id: "vong-nguyet",
      name: "Vọng Nguyệt",
      tier: "Set 6 bánh hoa ngàn lớp",
      price: "320.000đ",
      size: "Size bánh 70g",
      image: `${TT}/page-14.webp`,
      flavors: [
        "Hạt dẻ cười mơ tây",
        "Matcha dâu tây",
        "Đậu xanh sầu riêng",
        "Chanh vàng dừa non",
        "Sen táo đỏ hồng dẻo Đài Loan",
        "Trái cây nhiệt đới xốt xoài",
      ],
      note: "Chốt order và trả đơn vào thứ 3, thứ 6 hàng tuần",
    },
    {
      id: "thuong-nguyet",
      name: "Thưởng Nguyệt",
      tier: "Set 9 bánh hoa ngàn lớp",
      price: "449.000đ",
      size: "Size bánh 70g",
      image: `${TT}/page-15.webp`,
      flavors: [
        "6 vị Vọng Nguyệt",
        "Cốm non xốt sầu riêng",
        "Chocolate cà phê óc chó",
        "Khoai môn mochi chà bông",
      ],
      note: "Chốt order và trả đơn vào thứ 3, thứ 6 hàng tuần",
    },
  ],
  boxes: {
    title: "Giá hộp phụ thu khi chọn bánh lẻ",
    subtitle: "Nhắn gửi yêu thương, muôn vài lời chúc",
    included: ["1 bộ dao nĩa", "1 thiệp HSD / chúc mừng"],
    items: [
      { name: "Hộp set 4 bánh - mẫu Cát Tường", price: "115.000đ", image: `${TT}/page-08.webp` },
      { name: "Hộp set 4 bánh - mẫu Cúc An", price: "80.000đ", image: `${TT}/page-09.webp` },
      { name: "Hộp set 4 bánh - mẫu Dạ Hoa", price: "55.000đ", image: `${TT}/page-10.webp` },
      { name: "Hộp set 4 bánh - mẫu Lan Khuê", price: "55.000đ", image: `${TT}/page-11.webp` },
      { name: "Hộp set 6 bánh", price: "55.000đ", image: `${TT}/page-12.webp` },
      { name: "Hộp set 2 bánh", price: "20.000đ", image: `${TT}/page-13.webp` },
    ],
  },
  lookbook: Array.from({ length: 17 }, (_, i) => {
    const n = String(i + 1).padStart(2, "0");
    return {
      src: `${TT}/page-${n}.webp`,
      alt: `Catalogue bánh Trung thu Ann Home Mộc Hương Thu Nguyệt 2026 - trang ${i + 1}`,
    };
  }),
};

/* ============================== BÁNH KEM ============================== */
export const cakeStudio = {
  name: "Min's Bake Studio",
  tagline: "Bánh kem hiện đại, làm tươi mỗi ngày",
  intro:
    "Bánh sinh nhật đẹp · ít ngọt 30% · nguyên liệu rõ nguồn từ Anchor, Président, Valrhona. Mỗi chiếc bánh được làm riêng theo đơn — không tồn kho, không chất bảo quản.",
  hero: "/images/ext/cake-hero.webp",
  stats: [
    { value: "500+", label: "Đơn mỗi tháng" },
    { value: "4.9★", label: "Đánh giá khách hàng" },
    { value: "4 giờ", label: "Làm tươi, giao tận nơi" },
  ],
  marquee: [
    "Anchor Cream",
    "Président Butter",
    "Valrhona Chocolate",
    "Trái cây nhập khẩu",
    "Ít ngọt 30%",
    "Không chất bảo quản",
  ],
  reasons: [
    {
      no: "01",
      title: "Làm tươi mỗi ngày",
      text: "Không bánh tồn kho. Mỗi chiếc bánh chỉ bắt đầu được làm sau khi bạn đặt — đảm bảo độ tươi tối đa khi đến tay.",
    },
    {
      no: "02",
      title: "Đẹp & ít ngọt vừa đủ",
      text: "Thiết kế sang trọng, decor theo mẫu yêu thích. Giảm 30% đường so với công thức truyền thống — phù hợp cả trẻ nhỏ và người lớn.",
    },
    {
      no: "03",
      title: "Nguyên liệu rõ nguồn",
      text: "Cream Anchor, bơ Président, chocolate Valrhona. 100% không chất bảo quản, không phẩm màu hóa học.",
    },
  ],
  products: [
    {
      id: "chocolate-mousse",
      name: "Chocolate Mousse",
      price: "từ 350.000đ",
      meta: "Valrhona · 16cm",
      badge: "Bestseller",
      image:
        "/images/ext/cake-chocolate-mousse.webp",
    },
    {
      id: "banh-kem-dau-tuoi",
      name: "Bánh kem dâu tươi",
      price: "từ 420.000đ",
      meta: "Dâu Đà Lạt · 18cm",
      badge: "New",
      image:
        "/images/ext/cake-strawberry-fresh.webp",
    },
    {
      id: "tiramisu-classic",
      name: "Tiramisu Classic",
      price: "từ 380.000đ",
      meta: "Mascarpone · Espresso",
      badge: "Bestseller",
      image:
        "/images/ext/cake-tiramisu.webp",
    },
    {
      id: "matcha-cupcakes",
      name: "Matcha Cupcakes",
      price: "80.000đ / 6 cái",
      meta: "Matcha Uji · cream cheese",
      badge: "New",
      image:
        "/images/ext/cake-cupcakes.webp",
    },
    {
      id: "strawberry-shortcake",
      name: "Strawberry Shortcake",
      price: "từ 390.000đ",
      meta: "Kem tươi Anchor · 16cm",
      badge: "",
      image:
        "/images/ext/cake-shortcake.webp",
    },
    {
      id: "berry-entremet",
      name: "Berry Entremet",
      price: "từ 450.000đ",
      meta: "Mousse berry · glaze bóng",
      badge: "",
      image:
        "/images/ext/cake-berry-entremet.webp",
    },
  ],
  signature: {
    name: "Mousse Passion Fruit & Mango",
    desc: "Chua nhẹ từ chanh dây kết hợp ngọt dịu của xoài chín — tạo nên sự cân bằng hoàn hảo trong từng lớp mousse. Đây là chiếc bánh được khách hàng quay lại nhiều nhất tại studio.",
    image:
      "/images/ext/cake-signature-fruit.webp",
    specs: [
      { label: "Hương vị", value: "Chua nhẹ chanh dây, ngọt dịu xoài chín, mousse tan chảy." },
      { label: "Nguyên liệu", value: "Trái cây nhập khẩu, cream Anchor, gelatin halal." },
      { label: "Độ ngọt", value: "Giảm 30% đường — hợp người ăn kiêng, trẻ em từ 1 tuổi." },
      { label: "Kết cấu", value: "Mousse mềm mịn, gato xốp nhẹ, glaze bóng láng." },
    ],
  },
  story: {
    title: "Hành trình từ niềm đam mê đến những chiếc bánh handmade",
    paragraphs: [
      "Min's Bake Studio ra đời từ tình yêu thuần khiết với nghệ thuật làm bánh — và mong muốn mang đến những chiếc bánh kem hiện đại, sang trọng nhưng vẫn gần gũi với gia đình Việt.",
      "Chúng tôi tin rằng một chiếc bánh ngon không chỉ đến từ công thức chuẩn, mà còn từ sự tận tâm trong từng khâu — từ chọn nguyên liệu rõ nguồn gốc, đến cách thức làm tươi và decor theo mẫu yêu thích.",
    ],
    author: "— Min, founder",
    image:
      "/images/ext/class-instructor.webp",
    values: [
      { title: "Tươi mỗi ngày", text: "Làm bánh theo đơn đặt, đảm bảo độ tươi ngon tối đa khi đến tay." },
      { title: "Không bảo quản", text: "100% không phụ gia, chất tạo màu hay bảo quản hóa học." },
      { title: "An toàn cho bé", text: "Giảm đường, nguyên liệu an toàn cho bé từ 1 tuổi." },
      { title: "Cho cả nhà", text: "Hương vị cân bằng, phù hợp từ trẻ em đến người lớn tuổi." },
    ],
  },
  reviews: [
    {
      name: "Chị H***",
      meta: "Quận 2 · Khách hàng từ 2024",
      text: "Bánh mousse chocolate quá ngon! Mềm mịn, ngọt vừa phải, con mình 2 tuổi ăn rất thích. Sẽ ủng hộ lâu dài.",
    },
    {
      name: "Anh T***",
      meta: "Thủ Đức · Bánh sinh nhật cho bé",
      text: "Mình order bánh sinh nhật cho bé, bánh đẹp và ngon vượt mong đợi. Độ ngọt vừa phải, không ngấy. Recommend!",
    },
    {
      name: "Chị L***",
      meta: "Quận 1 · Đặt hàng tặng đồng nghiệp",
      text: "Cupcake matcha đẹp và ngon! Vị trà xanh thơm, kem cheese béo nhưng không ngán. Đóng gói cẩn thận.",
    },
  ],
};

/* ========================= LỚP HỌC LÀM BÁNH ========================= */
export const bakingClasses = {
  hero: "/images/ext/class-hero.webp",
  intro:
    "Ann Home mở lớp nhỏ 4-6 học viên, học trực tiếp cùng bếp trưởng. Bạn tự tay làm từ đầu đến cuối, mang bánh về và giữ lại công thức đã được điều chỉnh cho khẩu vị Việt.",
  includes: [
    "Nguyên liệu & dụng cụ có sẵn tại lớp",
    "Tài liệu công thức bản in mang về",
    "Mang toàn bộ bánh thành phẩm về nhà",
    "Hỗ trợ hỏi đáp sau khoá trong nhóm riêng",
    "Chứng nhận hoàn thành khoá học",
  ],
  courses: [
    {
      id: "lop-trung-thu",
      name: "Lớp bánh Trung thu handmade",
      duration: "1 buổi · 4 giờ",
      level: "Cơ bản",
      price: "1.200.000đ",
      seats: "4-6 học viên",
      desc: "Làm vỏ bánh nướng chuẩn mềm, sên nhân đậu xanh - hạt sen, tạo hình khuôn hoa và cách bảo quản bánh.",
      outcomes: ["Vỏ bánh nướng & bánh dẻo", "Sên 3 loại nhân", "Đóng gói set quà"],
      image:
        "/images/ext/class-dough.webp",
      popular: false,
    },
    {
      id: "lop-banh-kem",
      name: "Lớp bánh kem cơ bản",
      duration: "2 buổi · 6 giờ",
      level: "Cơ bản",
      price: "1.800.000đ",
      seats: "4-6 học viên",
      desc: "Từ cốt gato bông xốp, đánh kem tươi đúng độ đến bắt bông kem và decor bánh sinh nhật hoàn chỉnh.",
      outcomes: ["Cốt gato & chiffon", "Whipping cream ổn định", "Decor bánh sinh nhật"],
      image:
        "/images/ext/class-piping.webp",
      popular: true,
    },
    {
      id: "lop-mousse",
      name: "Lớp Mousse & Entremet nâng cao",
      duration: "3 buổi · 9 giờ",
      level: "Nâng cao",
      price: "2.900.000đ",
      seats: "4 học viên",
      desc: "Kỹ thuật mousse nhiều lớp, insert trái cây, mirror glaze bóng láng và cách phối vị theo mùa.",
      outcomes: ["Mousse 3 lớp", "Mirror glaze", "Phối vị & trình bày"],
      image:
        "/images/ext/class-berries.webp",
      popular: false,
    },
    {
      id: "lop-banh-healthy",
      name: "Lớp bánh mì & bánh healthy",
      duration: "1 buổi · 3 giờ",
      level: "Cơ bản",
      price: "890.000đ",
      seats: "4-6 học viên",
      desc: "Bánh mì nguyên cám, granola bar và bánh ít đường phù hợp thực đơn eat clean của cả gia đình.",
      outcomes: ["Bánh mì nguyên cám", "Granola & bar healthy", "Tính calo khẩu phần"],
      image:
        "/images/ext/class-kneading.webp",
      popular: false,
    },
  ],
  steps: [
    { no: "01", title: "Chọn khoá & đăng ký", text: "Nhắn Zalo hoặc gửi form, Ann Home tư vấn khoá phù hợp trình độ của bạn." },
    { no: "02", title: "Xác nhận lịch học", text: "Chốt ngày, giữ chỗ và nhận danh sách những gì cần mang theo." },
    { no: "03", title: "Học thực hành 100%", text: "Mỗi học viên một bộ dụng cụ riêng, làm trọn quy trình cùng bếp trưởng." },
    { no: "04", title: "Mang bánh về & đồng hành", text: "Nhận bánh, công thức in và vào nhóm riêng để hỏi đáp sau khoá." },
  ],
  gallery: [
    {
      src: "/images/ext/class-instructor.webp",
      alt: "Bếp trưởng Ann Home hướng dẫn học viên trong lớp làm bánh",
    },
    {
      src: "/images/ext/class-kneading.webp",
      alt: "Học viên nhào bột bánh mì tại lớp học Ann Home",
    },
    {
      src: "/images/ext/class-berries.webp",
      alt: "Trang trí trái cây tươi lên mặt bánh trong lớp học",
    },
    {
      src: "/images/ext/class-piping.webp",
      alt: "Học viên bắt bông kem bằng túi bắt kem",
    },
  ],
};

/* ===================== 4 DÒNG SẢN PHẨM (TRANG CHỦ) ===================== */
export const productLines = [
  {
    id: "eat-clean",
    kicker: "Eat clean & Healthy",
    name: "Bữa ăn Eat Clean",
    desc: "Phần ăn chuẩn dinh dưỡng, ghi rõ calories, giao tận nơi mỗi ngày tại TP.HCM.",
    image: "/images/2023_04_IMG_0769-scaled.webp",
    to: "/eat-clean",
    cta: "Xem thực đơn",
  },
  {
    id: "banh-trung-thu",
    kicker: "Mid-Autumn 2026",
    name: "Bánh Trung Thu",
    desc: "Bộ sưu tập Mộc Hương Thu Nguyệt: bánh truyền thống, sắc màu, hoa ngàn lớp & set quà.",
    image: "/images/tt/page-08.webp",
    to: "/banh-trung-thu",
    cta: "Xem bộ sưu tập",
  },
  {
    id: "banh-kem",
    kicker: "Min's Bake Studio",
    name: "Bánh Kem",
    desc: "Bánh sinh nhật hiện đại, ít ngọt 30%, làm tươi theo đơn với nguyên liệu cao cấp.",
    image:
      "/images/ext/cake-chocolate-mousse.webp",
    to: "/banh-kem",
    cta: "Xem mẫu bánh",
  },
  {
    id: "lop-hoc",
    kicker: "Baking Class",
    name: "Lớp Dạy Làm Bánh",
    desc: "Lớp nhỏ 4-6 người, học trực tiếp cùng bếp trưởng, mang bánh và công thức về nhà.",
    image:
      "/images/ext/class-hero.webp",
    to: "/lop-hoc-lam-banh",
    cta: "Xem khoá học",
  },
];
